import apiService from '@/services/apiService';

const actions = {
  getPartners({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/partners/find-with-paging', payload)
        .then((response) => {
          commit('SET_PARTNERS', response.data.data.results);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPartner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxelmarket/partners/${payload}`)
        .then((response) => {
          commit('SET_PARTNER', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderPartner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/partners/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postPartner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/partners', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putPartner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/partners/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delPartner({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`paxelmarket/partners/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },

};

export default actions;
